(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sb-connect"] && !Shopify.designMode) return;
  try {
    (() => {
    const popup = document.getElementById('SbConnect');
    if (!popup) return;
    const form = document.getElementById('SbNewsletterPopupForm');
    const read = (storage, key) => { try { return Number(window[storage].getItem(key)) || 0; } catch { return 0; } };
    const write = (storage, key, value) => { try { window[storage].setItem(key, String(value)); } catch {} };
    const pending = Date.now() - read('sessionStorage', 'sb-newsletter-pending') < 1800000;
    const returned = location.hash === '#SbNewsletterPopupForm' || pending;
    const success = popup.querySelector('[data-sb-success]');
    const error = popup.querySelector('[data-sb-error]');
    let timer;
    const close = () => {
      const focused = popup.contains(document.activeElement);
      popup.hidden = true;
      clearTimeout(timer);
      write('localStorage', 'sb-newsletter-dismissed', Date.now());
      if (focused) document.querySelector('#SbNewsletter input[type="email"]')?.focus({preventScroll:true});
    };
    popup.querySelectorAll('[data-sb-close]').forEach(button => button.addEventListener('click', close));
    popup.addEventListener('keydown', event => { if (event.key === 'Escape') { event.preventDefault(); close(); } });
    form.addEventListener('submit', () => { write('sessionStorage', 'sb-newsletter-pending', Date.now()); });
    if (returned && (success || error)) {
      popup.hidden = false;
      (success || error).focus({preventScroll:true});
      write('sessionStorage', 'sb-newsletter-pending', 0);
      if (success) write('localStorage', 'sb-newsletter-subscribed', Date.now());
      return;
    }
    if (success || error || ['cart', 'customers/account', 'customers/login', 'challenge'].includes(popup.dataset.page) || window.Shopify?.designMode) return;
    if (Date.now() - read('localStorage', 'sb-newsletter-dismissed') < 604800000 || Date.now() - read('localStorage', 'sb-newsletter-subscribed') < 31536000000) return;
    const showWhenReady = () => {
      const active = document.activeElement;
      const blocked = document.hidden || (active && /^(INPUT|TEXTAREA|SELECT)$/.test(active.tagName)) || [...document.querySelectorAll('dialog[open], [aria-modal="true"], #shopify-pc__banner')].some(node => node.getClientRects().length && getComputedStyle(node).visibility !== 'hidden' && getComputedStyle(node).display !== 'none');
      if (blocked) { timer = setTimeout(showWhenReady, 3000); return; }
      popup.hidden = false;
    };
    timer = setTimeout(showWhenReady, 12000);
  })();
  } catch(e) { console.error(e); }
})();

})();
